import styled from 'styled-components';

import { mediaQueries } from 'theme/mediaQueries';

export const ErrorBoundaryWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    /* 100vh for older browsers, 100dvh for modern browsers with dynamic viewport handling */
    min-height: 100vh;
    min-height: 100dvh;

    > div {
        max-width: 432px;
        padding: 0 40px;

        ${mediaQueries.tablet} {
            padding: 0 24px;
        }
    }
`;
